var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"index"}},[_c('WaluntIndex',{attrs:{"msg":"111是大大大大大"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }